import { observable } from 'mobx'

export default class NovoDirecionamentoStore {

    @observable ceHouse;
    @observable codRef;
    @observable emails;
    @observable adicionar;
    @observable loadingImport;
    @observable listaImportacao;
    @observable listaAnexos;
    @observable aviso
    
    constructor(service) {
        this.ceHouse = ""
        this.emails = ""
        this.codRef = ""
        
        this.adicionar = false
        this.loadingImport = false
        
        this.listaImportacao = []
        this.listaAnexos = []

        this.aviso = ""

        this.service = service
    }

    setDadosEdicao = (row) => {
        this.ceHouse = row.CeHouse
        this.codRef = row.CodRef
        this.emails = row.Email
        row.Anexo ? this.listaAnexos.push(row.Anexo) : this.listaAnexos = []
    }

    setCeHouse = (value) => {
        this.ceHouse = value
    }
    
    setCodRef = (value) => {
        this.codRef = value
    }
    
    setEmails= (value) => {
        this.emails = value
    }

    anexarArquivo = (event) => {
        this.listaAnexos = [] //considerando sempre que só existirá 1 anexo
        if(event.target.files){
            Array.from(event.target.files).map(arquivo => {
                this.listaAnexos.push({ file: arquivo, name: arquivo.name.replace(/[^a-zA-Z0-9\.]/g, "") })
            })
        }
    }

    removerAnexo = () => {
        this.listaAnexos = []
    }

    adicionarPlanilha = (event) => {
        this.loadingImport = true
        if(event.target.files){
            let arquivo = new FormData()
            arquivo.append("file",event.target.files[0])
            this.service.TeconImportarXls(arquivo).then(response => {
                //TODO Validação and stuff
                if(response && response.data) {
                    if(response.data.Sucesso){
                        this.listaImportacao = response.data.Lista
                    }else{
                        this.aviso = response.data.MensagemErro
                    }
                }
            }).catch(err => console.log(err)
            ).finally(() => {this.loadingImport = false})
        }
    }

}


// WEBPACK FOOTER //
// ./src/modules/direcionamento/tecon/stores/NovoDirecionamentoStore.js